import { EstateStatus } from '@/modules/estate/constants/EstateStatus';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class WorkflowEstateStatusTrigger extends BaseEntityModel {
  id?: number;

  status?: string;

  constructor(model: Partial<WorkflowEstateStatusTrigger> = {}) {
    super(model);

    this.id = model.id;
    this.status = model.status;
  }

  get statusText(): string {
    return EstateStatus.getByKey(this.status).value;
  }

  get statusColor(): string {
    return EstateStatus.getByKey(this.status).color;
  }
}
